module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('a', {
    staticClass: "calibre12",
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0006#frontmatter01"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rfrontmatter02"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWERFUL")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALLY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section01"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section01"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Why We Must Rethink Our Parenting—and Our World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section02"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section02"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The “Generation Peace” Profile")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section03"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section03"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Spreading Compassion, Not Blame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section04"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section04"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Note on Scientific and Gender References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section05"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section05"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Invisible Power Within You")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section06"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section06"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Nature-Nurture Embrace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section07"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section07"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Consciousness Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section08"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section08"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Can You Get Your Head Around This Idea About...Your Head?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section09"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section09"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Mind Moves Matter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section10"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section10"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("We Are the MVPs in Our Own Evolution!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter02section11"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#frontmatter02section11"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RO")]), _vm._v("-G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOICES")]), _vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULTIVATING A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTILE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IND AND")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section01"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section01"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Are You Creating, or Recreating?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section02"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section02"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("You Are Always Self-Creating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section03"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section03"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Where’s Your Head At?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section04"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section04"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Revising Old Programming")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section05"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section05"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Power of Appreciation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section06"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section06"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("What Head Are You In?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section07"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section07"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("This Is Your Brain, in Three Acts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section08"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section08"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Prefrontals (Human.04, the Upgrade")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section09"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section09"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Only Question, Always: Growth or Protection?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section10"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section10"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Installing the Upgrade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section11"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section11"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Cellular Genius")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section12"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section12"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Glitch or a Glimmer in the Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section13"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section13"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Growth-Protection Regeneration Gap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section14"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section14"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Cells Are Excellent Students")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section15"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section15"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Cultivating Fertility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section16"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section16"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Fertile Mind, Fertile Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section17"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section17"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section18"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#chapter01section18"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP TWO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTUNED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCEPTION")]), _vm._v("—A Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UANTUM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLABORATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Womb Ecology, World Ecology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Attuned Conception—A Quantum Collaboration with Chaos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Most Notable Moment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Power of Gracious Thought")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Simply, Let Us Pay Attention")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("In the Realm of the Spiritual")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Persistence of Primal Memory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("How We Begin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Nourishing Conception")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Laying the Foundation for Success")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Sensitive Dependence on Initial Conditions, Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Twenty-First Century Concern: EMFs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section13"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Radiance of Our Inner Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section14"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Conceiving Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section15"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter02section16"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#chapter02section16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP THREE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADIANT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGNANCY")]), _vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARNESSING THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER OF THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Wonder of Embryonic Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Instructions for Growing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Risk in the Mirror: Teratogens in the New Age")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("My Mother’s Psyche, My Self’s Psyche")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The S Word")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Nature’s Elegant Survival Scheme")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Sensitive Dependence on Initial Conditions, Part 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Growth or Protection = Peace or Defense")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Intelligence of Adaptation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Teaching Future Peacemakers a Peaceful World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("What’s a Mother-to-Be to Do?!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Prenatal Learning: What Is the World, Mommy, Through Your Eyes?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section13"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Fathering a Peaceful Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section14"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Building a Healthy Baby Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section15"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Tend Your Inner Knowing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section16"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Raising Generation Peace: The Collective Endeavor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section17"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter03section18"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#chapter03section18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP FOUR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPOWERED")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTH")]), _vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LTIMATE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPRESSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birthing for a Peaceful World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Who Starts Labor?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birth from Baby’s Point of View")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section04"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Disturbing Birth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Joining Forces with Birth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birth from the Mother’s Point of View")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("When Cesarean Is the Way You Birth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birth on the Brain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“"), _c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birth’s Epilogue”: A Secret Key to Peace and Joy!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Birth as an Ecstatic Rite of Passage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter04section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#chapter04section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP FIVE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURE’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAN")]), _vm._v("—I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSTALLING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACEMAKER")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDWARE IN")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Best Investment for Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Two Postpartum Portraits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Nurturing Connection: Weaving Peace as Your Child’s Foundation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("A Poignant Glimpse of Attachment Research History")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Separation as Trauma: Baby’s POV")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Separation: Mother’s POV")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Postpartum Parenting for Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Sheltering the Tender Beginnings of Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Of Love and Milk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Nursing Generation Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Special Circumstances: Adoption, the NICU and Other Separations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Attuned Connection: The Neurobiology of Transformative Possibilities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section13"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Sharing States")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section14"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Why This Bit of Neuroscience Matters for Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section15"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Lifelong Lessons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section16"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Takeaway Message for Parents-for-Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section17"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Nine Months In, Nine Months Out…and Then")]), _vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section18"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Awareness Fosters Attunement")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section19"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Telling Our Birth Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section20"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Birth of a Mother")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section21"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("When Joylessness Takes Over")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section22"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("An Organic Perspective on Postpartum Depression")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section23"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Connection and Conscience: The Foundations of Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section24"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Yikes—Are We Up to This Calling?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section25"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter05section26"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#chapter05section26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP SIX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCHANTED")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARS")]), _vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODDLERS THROUGH")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDERGARTEN:")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAYING")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTTERING AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Rubber Hits the Road")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("You Are Your Child’s First Teacher")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("How a Young Child Really Learns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("How Parents Can Build Their Child’s Brain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Learning Peace by Living Peace: Nourishing a Child’s Will")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Challenge: Cultivating Calm, Loving Authority")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Staring into the Void")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Numbing Them Down")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("TMTS (Too Much Too Soon")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Discipline, or Being a Leader of Joyful Followers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("How to De-Peace Your Child: Spanking, Shaming and Isolating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Fostering Growth While Keeping Peaceful Boundaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section13"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("What’s All This Hoopla About Praise?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section14"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Cost of a “Head Start")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section15"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Protecting the Bud, Envisioning the Blossom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section16"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter06section17"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#chapter06section17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEP SEVEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEPHERD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEM INTO THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPING AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Awakening of Feeling Intelligence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Every Moment Is the Moment to Begin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section03"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Modeling Peace, Passion and Possibilities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Knowing Your Child, Yourself, and Your Discipline Watchword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section05"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Seeding Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section06"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Confronting the Media Hydra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section07"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Television as a Neuro-Violent Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section08"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Erosion of Childhood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section09"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Remembering You’re a Hero")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section10"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("The Challenge of Formal Education")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section11"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("How Then Shall We Educate?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section12"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("I’ve Got Good News and Bleak News")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section13"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Find a Good Lifeboat (or Build One")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section14"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("An Education that Is Present with Students")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section15"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Educating Toward an Awareness of Humanity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section16"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Snapshots of Two Schooling Paradigms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section17"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Some Thoughts on Alternatives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section18"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Home Learning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section19"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Finding Peace in Extracurricular Activities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section20"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("And While That Precious Window Is Still Open")]), _vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section21"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Our Children, Ourselves")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section22"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Principles to Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter07section23"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#chapter07section23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PILOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter01section01"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#backmatter01section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Mother and Child Communion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter01section02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#backmatter01section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Raising Human Nature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter01section03"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#backmatter01section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Raising Humanity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb",
    attrs: {
      "id": "rbackmatter01section04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#backmatter01section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("Farewell and Fair Winds")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0016#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rChapter04"
    }
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0017#Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54010ed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0005.vue
// module id = 72
// module chunks = 0